import { styled } from "@mui/material";

export const IconWrapper = styled("div")`
  display: flex;
  align-items: center;
  width: 15px;
  position: relative;
  top: -1px;
`;
